// extracted by mini-css-extract-plugin
module.exports = {"container":"aed17b9412--container--KOYjJ","fade":"aed17b9412--fade--zRBkk","chat-icon":"aed17b9412--chat-icon--DA128","content":"aed17b9412--content--Q4oH1"};